import { EFontFamily } from 'src/styles/theme/components/NGText/NGText.enum';
import { ETextColor } from 'src/styles/theme/utils/enums';
import { addTransition, getTextColor } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

const styledUncheckedBackground = css`
	background: linear-gradient(
		120.86deg,
		rgba(217, 246, 250, 0.4) 14.03%,
		rgba(218, 227, 248, 0.4) 57.91%,
		rgba(185, 228, 255, 0.4) 100%
	);
`;

export const StyledSwitchWrapper = styled.div`
	position: relative;
	display: flex;
	gap: 32px;
`;

export const StyledLabel = styled.label<{ textColor?: ETextColor }>`
	font-weight: 400;
	font-size: 14px;
	line-height: 17px;
	cursor: pointer;
	user-select: none;

	font-family: ${EFontFamily.lato};

	${(p) => css`
		color: ${getTextColor(p)};
	`}
`;

export const StyledSwitchTrack = styled.label`
		position: absolute;
		top: 5px;
		left: 0;
		width: 30px;
		height: 10px;
		border-radius: 35px;
		cursor: pointer;
		${styledUncheckedBackground}

		// switch Thumb
		&::after {
			content: '';
			display: block;
			border-radius: 50%;
			width: 16px;
			position: relative;
			bottom: 3px;
			left: 0px;
			height: 16px;
			background: #515151;
			${addTransition()}
		}
		&::before {
			content: '';
			display: block;
			position: absolute;
			z-index: 30; 2;
			top: 3.5px;
			left: 2px;
			width: 11px;
			height: 2px;
			background: #9F8C6C;
			${addTransition()}
		}
`;

export const StyledSwitch = styled.input(
	({ theme }) => `
		opacity: 0;
		z-index: 30; 20;
		border-radius: 15px;
		cursor: pointer;

		&:checked + ${StyledSwitchTrack}{
			background: ${theme.colors.darkGold};
		}

		&:checked + ${StyledSwitchTrack} {
			&::after {
				background: ${theme.colors.gold};
				left: 14px;
			}
			&::before {
				background: ${theme.colors.gold};
				left: 16px;
			}
		}

		&[disabled]:checked + ${StyledSwitchTrack} {
			background: ${theme.colors.darkGold};

			&::after {
				background: ${theme.colors.grey};
			}
			&::before {
				background: ${theme.colors.grey};
			}
		}

		&[disabled]:not(:checked) + ${StyledSwitchTrack} {
			${styledUncheckedBackground}

			&::after {
				background: #515151;;
			}
			&::before {
				background: #9F8C6C;
			}
		}

		&[disabled]:active + ${StyledSwitchTrack} {
			&::after {
				left: 8px;
			}
			&::before {
				left: 10px;
			}
		}

		&[disabled]:active:not(:checked) + ${StyledSwitchTrack} {
			&::after {
				left: 6px;
			}
			&::before {
				left: 8px;
			}
		}

		${addTransition()}
	`
);

export const StyledErrorText = styled.p`
	text-align: left;
	font-size: 12px;
	line-height: 14px;
	min-height: 14px;
	${(p) => css`
		margin-top: ${p.theme.spacing['5xs']};
		color: ${p.theme.colors.text.error};
	`}
`;
